export const FEEDBACK = {
    POSITIVE: 'choice/feedback_up',
    NEGATIVE: 'choice/feedback_down',
    NEUTRAL: 'nil',
};
